import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Popconfirm,
  notification,
  Tooltip,
  Drawer,
  Modal,
  message,
  Tabs,
  Timeline,
  Tag,
  Spin,
} from "antd";
import {
  OrderedListOutlined,
  EditOutlined,
  DeleteOutlined,
  FormOutlined,
  EyeOutlined,
  FileExcelOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import OrderTableFilter from "../Filters/OrderTableFilter";
import moment from "moment";
import OrderUpdateStatusForm from "./OrderUpdateStatusForm";
import OrderDeliveryAddForm from "../Forms/OrderDeliveryAddForm";
import config from "../../util/ApiforContext";

const OrderList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "SİPARİŞ LİSTESİ" });
  const [quotes, setQuotes] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const history = useHistory();
  const [orderDeliveryAddModalVisible, setOrderDeliveryAddModalVisible] =
    useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [approvalHistoryModal, setApprovalHistoryModal] = useState(false);
  const [approvalHistory, setApprovalHistory] = useState({ data: [], loading: false });
  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);
  const [permissions, setPermissions] = useState({
    canAdd: false,
    canUpdate: false,
    canDelete: false,
    canApprove: false,
  });

  useEffect(() => {
    RequestHandler.get("/TenantUser/GetApprovalContext").then((res) => {
      if (res?.permissions?.order) {
        setPermissions({
          canAdd: res?.isAdmin || res.permissions.order.canAdd,
          canUpdate: res?.isAdmin || res.permissions.order.canUpdate,
          canDelete: res?.isAdmin || res.permissions.order.canDelete,
          canApprove: res?.isAdmin || res.permissions.order.canApprove,
        });
      }
    });
  }, []);

  const getTableData = () => {
    setQuotes({
      ...quotes,
      loading: true,
    });

    const { skip, take, filter, activeTab } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    let conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      if (activeTab === "1") {
        conditions.push("isApproved eq true");
      } else if (activeTab === "2") {
        conditions.push("isrejected eq true");
      }
      query = `&$filter=${conditions.join(" and ")}`;
    }

    if (activeTab === "0") {
      RequestHandler.get(
        `/Order?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setQuotes({
          data: response.value,
          loading: false,
          total: response["@odata.count"],
        });
      });
    } else if (activeTab === "1") {
      RequestHandler.get(
        `/Order/GetApprovedHistoryListQueryableOdata?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setQuotes({
          data: response,
          loading: false,
          total: response?.length || 0,
        });
      });
    } else if (activeTab === "2") {
      RequestHandler.get(
        `/Order/GetApprovedHistoryListQueryableOdata?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setQuotes({
          data: response,
          loading: false,
          total: response?.length || 0,
        });
      });
    }
  };

  const handleOnClickUpdate = (record) => {
    history.push({
      pathname: `/update-order/${record.id}`,
    });
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const handleOnClickDelete = (row) => {
    // if (row.addUserId !== localStorage.getItem("userId") && !isEditAllowed) {
    //   openNotificationForNotAuthWithIcon("warning");
    //   return;
    // }

    RequestHandler.delete(`/Order/${row.id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const handleOnClickView = (record) => {
    history.push({
      pathname: `/update-order/${record.id}`,
      search: "?mode=view",
    });
  };

  const handleShowApprovalHistory = (record) => {
    setApprovalHistoryModal(true);
    setApprovalHistory({ data: [], loading: true });
    RequestHandler.get(`/PurchaseRequest/GetApprovalHistory/${record.id}/2`).then((res) => {
      setApprovalHistory({ data: res || [], loading: false });
    }).catch(() => {
      setApprovalHistory({ data: [], loading: false });
    });
  };

  const columns = [
    {
      title: "Sipariş Kodu",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Sipariş Açıklaması",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Teslimat Durumu",
      dataIndex: "deliveryStatus",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Sipariş Tarihi",
      dataIndex: "orderDate",
      key: "orderDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY") : "-"),
    },
    {
      title: "Sipariş Tipi",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.purchaaseRequestId
          ? "Talebe İstinaden"
          : row.quoteId
          ? "Teklife İstinaden"
          : "Doğrudan Sipariş",
    },
    {
      title: "Proje Adı",
      dataIndex: "firmName",
      key: "firmName",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Ekleyen Kullanıcı",
      dataIndex: "addUserName",
      key: "addUserName",
    },
    {
      title: "Eklenme Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      render: (data) =>
        data ? moment(data).format("DD.MM.YYYY HH:mm:ss") : "-",
    },
    {
      title: "Son Güncelleyen Kullanıcı",
      dataIndex: "updateUserName",
      key: "updateUserName",
    },

    {
      title: "Son Güncellenme Tarihi",
      dataIndex: "updateDate",
      key: "updateDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY HH:mm") : "-"),
    },

    {
      title: "Durum",
      dataIndex: "orderStatusString",
      key: "orderStatusString",
      render: (text, record) => (
        <Tag
          color={record.statusByte === 3 ? "red" : record.statusByte === 1 ? "green" : record.statusByte === 2 ? "green" : "blue"}
          style={{ cursor: "pointer" }}
          onClick={() => handleShowApprovalHistory(record)}
        >
          <HistoryOutlined style={{ marginRight: 4 }} />
          {text}
        </Tag>
      ),
    },
    {
      title: "Teslimat Kaydı Ekle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        quotes.total >= 1 && row.statusByte == 2 ? (
          <a
            onClick={() => {
              setSelectedOrderId(row.id);
              setOrderDeliveryAddModalVisible(true);
            }}
          >
            <EditOutlined style={{ color: "green", fontSize: "130%" }} />
          </a>
        ) : null,
    },
    {
      title: "Görüntüle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        quotes.total >= 1 && row?.canApprove ? (
          <a onClick={() => handleOnClickView(row)}>
            <EyeOutlined style={{ color: "blue", fontSize: "130%" }} />
          </a>
        ) : null,
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        quotes.total >= 1 && row?.canUpdate === true ? (
          <a onClick={() => handleOnClickUpdate(row)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        ) : null,
    },

    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data, row) =>
        row?.canDelete === true ? (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleOnClickDelete(row)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <DeleteOutlined />
            </a>
          </Popconfirm>
        ) : null,
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
      activeTab: tableDataQueryOptions.activeTab,
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
        activeTab: tableDataQueryOptions.activeTab,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        activeTab: tableDataQueryOptions.activeTab,
      };
    });
  };

  const dataStateChange = (e) => {
    setQuotes(e);
  };

  const onSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const handleOnClickStatusUpdate = (row) => {
    setUpdateFormData({
      id: row.id,
      name: row.name,
      orderStatus: row.statusByte,
    });
    setUpdateFormVisibility(true);
  };

  const exportExcel = () => {
    const hide = message.loading("Excel indiriliyor...", 0);
    const { filter } = tableDataQueryOptions;
    RequestHandler.post(
      `/OrderExcel/ExportExcel`,
      { Query: filter == "" ? "" : "$filter=" + filter },
      false,
      {
        rawResponse: true,
      }
    ).then((res) => {
      if (res.status == 200) {
        window.open(
          `${config.apiUrl}/OrderExcel/DownloadExcelList?fileName=${
            res.data
          }&t=${RequestHandler.getToken()}`
        );
      }
      hide();
    });
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={exportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
          <a href="/create-order">
            <Button
              style={{ marginRight: 15 }}
              type="primary"
              hidden={!permissions.canAdd}
            >
              Sipariş Ekle
            </Button>
          </a>
        </Col>
      </Row>

      <OrderTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Tabs defaultActiveKey={"0"} onChange={onTabChange}>
        <Tabs.TabPane tab="Aktif" key="0" />
        <Tabs.TabPane tab="Onaylanan" key="1" />
        <Tabs.TabPane tab="Reddedilen" key="2" />
      </Tabs>

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={quotes.data}
            loading={quotes.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: quotes.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>

      <Drawer
        id="updateQuoteDrawer"
        title="Durum Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <OrderUpdateStatusForm data={updateFormData} onSuccess={onSuccess} />
      </Drawer>

      <Modal
        visible={orderDeliveryAddModalVisible}
        title="Teslimat Kaydı"
        footer={null}
        onCancel={() => setOrderDeliveryAddModalVisible(false)}
        width={800}
        destroyOnClose={true}
      >
        <OrderDeliveryAddForm
          onCancel={() => setOrderDeliveryAddModalVisible(false)}
          onSuccess={() => {
            setOrderDeliveryAddModalVisible(false);
          }}
          orderId={selectedOrderId}
        />
      </Modal>

      <Modal
        title="Onay Geçmişi"
        visible={approvalHistoryModal}
        onCancel={() => setApprovalHistoryModal(false)}
        footer={null}
        width={700}
      >
        {approvalHistory.loading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin size="large" />
          </div>
        ) : approvalHistory.data.length === 0 ? (
          <Empty description="Onay geçmişi bulunamadı." />
        ) : (
          <Timeline mode="left" style={{ marginTop: 20 }}>
            {approvalHistory.data.map((item) => (
              <Timeline.Item
                key={item.id}
                color={item.isApproval ? "green" : item.isReject ? "red" : "blue"}
                dot={
                  item.isApproval ? (
                    <CheckCircleOutlined style={{ fontSize: 16 }} />
                  ) : item.isReject ? (
                    <CloseCircleOutlined style={{ fontSize: 16 }} />
                  ) : (
                    <InfoCircleOutlined style={{ fontSize: 16 }} />
                  )
                }
              >
                <div>
                  <strong>{item.userName}</strong>
                  <span style={{ color: "#999", marginLeft: 8 }}>
                    {moment(item.addDate).format("DD.MM.YYYY HH:mm")}
                  </span>
                </div>
                <div style={{ marginTop: 4 }}>
                  {item.approvalRoleName && (
                    <Tag color="default">{item.approvalRoleName}</Tag>
                  )}
                  {item.isApproval && <Tag color="success">Onayladı</Tag>}
                  {item.isReject && <Tag color="error">Reddetti</Tag>}
                  {!item.isApproval && !item.isReject && <Tag color="processing">Sipariş Oluşturuldu</Tag>}
                </div>
                {item.nextStatusName && (
                  <div style={{ marginTop: 4, fontSize: 12, color: "#666" }}>
                    {item.nextStatusName}
                  </div>
                )}
                {item.reason && (
                  <div style={{ marginTop: 4, color: "#ff4d4f", fontSize: 12 }}>
                    <strong>Sebep:</strong> {item.reason}
                  </div>
                )}
              </Timeline.Item>
            ))}
          </Timeline>
        )}
      </Modal>
    </>
  );
};

export default OrderList;
